// Reconoce los enlaces de documento que el backend acepta, para avisar mientras
// se escribe en vez de esperar al error del servidor.
//
// Esto es comodidad de interfaz, NO la defensa: el backend valida el host otra
// vez al guardar (ver api/utils/enlaces.py). La lista de aquí es un espejo de la
// de allá; si se agrega un destino, se agrega en los dos lados.

const HOSTS_DOCUMENTO = [
    "docs.google.com",
    "drive.google.com",
    "onedrive.live.com",
    "1drv.ms",
];

// OneDrive empresarial vive en `<tenant>-my.sharepoint.com`, así que aquí no
// alcanza la igualdad exacta. El punto inicial es lo que impide que
// `evilsharepoint.com` calce.
const SUFIJOS_DOCUMENTO = [".sharepoint.com"];

export function esEnlaceDeDocumento(url) {
    if (!url) {
        return false;
    }

    let partes;
    try {
        partes = new URL(String(url).trim());
    } catch (error) {
        // Todavía no es una URL completa: pasa mientras se escribe.
        return false;
    }

    if (partes.protocol !== "http:" && partes.protocol !== "https:") {
        return false;
    }

    // Se mira `hostname` y no `host` ni la URL entera: `hostname` deja fuera las
    // credenciales, así que `https://drive.google.com@evil.com/` se resuelve por
    // lo que es, `evil.com`.
    const host = partes.hostname.toLowerCase();

    return (
        HOSTS_DOCUMENTO.indexOf(host) !== -1 ||
        SUFIJOS_DOCUMENTO.some((sufijo) => host.endsWith(sufijo))
    );
}
